module.exports = __webpack_public_path__ + "static/media/Sirius Black 1.c2546a07.jpg";